<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxFlex class="flex flex-row justify-between items-center flex-1-0-auto">
            <span class="title dialog-title">New Message</span>
            <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0 simple-scroll">

        <form name="composeForm" [formGroup]="composeForm" class="compose-form flex flex-col" fxFlex>

            <mat-form-field>
                <input matInput name="from"
                       placeholder="From"
                       formControlName="from"
                       type="email">
            </mat-form-field>

            <mat-form-field>
                <input matInput name="to"
                       placeholder="To"
                       formControlName="to"
                       type="email" required>
            </mat-form-field>

            <mat-form-field>
                <input matInput
                       name="cc"
                       placeholder="Cc"
                       formControlName="cc"
                       type="email">
            </mat-form-field>

            <mat-form-field>
                <input matInput
                       name="bcc"
                       placeholder="Bcc"
                       formControlName="bcc"
                       type="email">
            </mat-form-field>

            <mat-form-field>
                <input matInput name="subject"
                       placeholder="Subject"
                       formControlName="subject">
            </mat-form-field>

            <mat-form-field>
            <textarea matInput name="message"
                      placeholder="Message"
                      formControlName="message"
                      rows="6">
            </textarea>
            </mat-form-field>

            <div class="attachment-list">

                <div class="attachment flex flex-row justify-between items-center">
                    <div>
                        <span class="filename">attachment-2.doc</span>
                        <span class="size">(12 Kb)</span>
                    </div>

                    <button mat-icon-button aria-label="Delete attachment">
                        <mat-icon class="s-16">close</mat-icon>
                    </button>
                </div>

                <div class="attachment flex flex-row justify-between items-center">
                    <div>
                        <span class="filename">attachment-1.jpg</span>
                        <span class="size">(350 Kb)</span>
                    </div>

                    <button mat-icon-button aria-label="Delete attachment">
                        <mat-icon class="s-16">close</mat-icon>
                    </button>
                </div>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16 flex flex-row justify-between items-center">
        <div>
            <button mat-raised-button
                    (click)="dialogRef.close(['send',composeForm])"
                    class="save-button mat-accent"
                    [disabled]="composeForm.invalid"
                    aria-label="SAVE">
                SEND
            </button>

            <button mat-icon-button matTooltip="Attach a file">
                <mat-icon>attach_file</mat-icon>
            </button>
        </div>

        <button mat-icon-button (click)="dialogRef.close(['delete',composeForm])" aria-label="Delete"
                matTooltip="Delete">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
</div>
